module.exports = __webpack_public_path__ + "static/media/16UNODC26.f0d15ed6.jpg";